/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React, {createContext, useEffect, useState} from 'react';
import {STEP_NOT_STARTED} from "./constants/constants";

const AppContext = createContext({
});

export const AppContextProvider = props => {
  const [mobileDevice, setMobileDevice] = useState(null);
  const [sid, setSid] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [plainTextPhoneNumber, setPlainTextPhoneNumber] = useState('');
  const [deliveryMethod, setDeliveryMethod] = useState( '');
  const [firstName, setFirstName] = useState( '');
  const [lastName, setLastName] = useState( '');
  const [qrCodeUrl, setQrCodeUrl] = useState( '');
  const [hash, setHash] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [hashStepsStatus, setHashStepsStatus] = useState({rsaSetup: STEP_NOT_STARTED, sloSetup: STEP_NOT_STARTED, sloTest: false});
  const [passwordCreated, setPasswordCreated] = useState(false);
  const [mppUrl, setMppUrl] = useState('Link Not Provided');
  const [expirationTime, setExpirationTime] = useState('');
  const [isSoftTokenEnabled, setIsSoftTokenEnabled] = useState(false);
  const [isSmartLogonEnabled, setIsSmartLogonEnabled] = useState(false);

  useEffect(() => {
    if (props.mppUrl !== undefined) {
      setMppUrl(props.mppUrl);
    }
  }, [props.mppUrl]);

  return (<AppContext.Provider value={{
    loadAA: props.loadAA,
    sidContext: [sid, setSid],
    phoneNumberContext: [phoneNumber, setPhoneNumber],
    plainTextPhoneNumberContext: [plainTextPhoneNumber, setPlainTextPhoneNumber],
    deliveryMethodContext: [ deliveryMethod, setDeliveryMethod],
    firstNameContext: [ firstName, setFirstName],
    lastNameContext: [ lastName, setLastName],
    mobileDeviceContext: [mobileDevice, setMobileDevice],
    qrCodeContext: [qrCodeUrl, setQrCodeUrl],
    hashContext: [hash, setHash],
    passwordCreatedContext: [passwordCreated, setPasswordCreated],
    transactionIdContext: [transactionId, setTransactionId],
    mppUrlContext: [ mppUrl, setMppUrl ],
    expirationTimeContext: [expirationTime, setExpirationTime],
    hashStepsStatusContext: [hashStepsStatus, setHashStepsStatus],
    isSoftTokenEnabledContext: [isSoftTokenEnabled, setIsSoftTokenEnabled],
    isSmartLogonEnabledContext: [isSmartLogonEnabled, setIsSmartLogonEnabled],
    external: props.external
  }}>
    {props.children}
  </AppContext.Provider>);
};
export default AppContext;
